module.exports = __webpack_public_path__ + "assets/icons/sessions-logo.2b001df688218807e7c5ec057d6fc2b9.svg";